import { i18n } from '../../i18n/i18n';
import { DataService } from '../../services/data_service';
import { MessageInstructorResponse, MessageInstructorModel, ResponseType } from './message-instructor.model';

/**
 * Client for sending messages to the instructor.
 */
export class MessageInstructorClient {
  private dataService: DataService;

  /**
   * Creates an instance of MessageInstructorClient and initializes the data service.
   */
  constructor() {
    this.dataService = DataService.getInstance('');
  }

  /**
   * Sends a message to the instructor using the provided message instruction model.
   * Shows a toast notification on success or failure.
   *
   * @param messageInstruction - The message instruction model containing message details
   * @returns A promise that resolves to "ok" on success or "error" on failure
   */
  sendMessageToInstructor(messageInstruction: MessageInstructorModel): Promise<string> {
    return this.dataService
      .post<MessageInstructorResponse>('/messages/to-author.json', messageInstruction)
      .then((res) => {
        window.LuAnywhere.services.toast.getInstance().showToast({ message: res.success.title });
        return ResponseType.SUCCESS;
      })
      .catch(() => {
        window.LuAnywhere.services.toast
          .getInstance()
          .showToast({ message: i18n('lua.message_instructor.error_message'), variant: 'error' });
        return ResponseType.ERROR;
      });
  }
}
